'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogBiddingIfNeeded = exports.LOAD_CATALOG_BIDDING_SUCCESS = exports.LOAD_CATALOG_BIDDING_REQUEST = exports.LOAD_CATALOG_BIDDING_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = require('../api');

var _user = require('./user');

var _config = require('./config');

var _loaded = require('./loaded');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATALOG_BIDDING_FAIL = exports.LOAD_CATALOG_BIDDING_FAIL = 'la/domain/catalogBidding/LOAD_FAIL';
var LOAD_CATALOG_BIDDING_REQUEST = exports.LOAD_CATALOG_BIDDING_REQUEST = 'la/domain/catalogBidding/LOAD_REQUEST';
var LOAD_CATALOG_BIDDING_SUCCESS = exports.LOAD_CATALOG_BIDDING_SUCCESS = 'la/domain/catalogBidding/LOAD_SUCCESS';

/* ACTION CREATORS */
var fetchIfNeeded = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var catalogId = _ref2.catalogId,
            dispatch = _ref2.dispatch,
            getState = _ref2.getState;
        var state, authToken, deployment, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        state = getState();

                        if (!(0, _loaded.shouldFetchBiddingInfoForCatalog)(state, catalogId)) {
                            _context.next = 15;
                            break;
                        }

                        _context.prev = 2;
                        authToken = (0, _user.getAuthToken)(state);
                        deployment = (0, _config.getDeployment)(state);

                        dispatch({
                            meta: { actionTime: Date.now() },
                            payload: catalogId,
                            type: LOAD_CATALOG_BIDDING_REQUEST
                        });
                        _context.next = 8;
                        return _api.BiddingInfo.fetchCatalogBidding({ authToken: authToken, catalogId: catalogId, deployment: deployment });

                    case 8:
                        response = _context.sent;

                        dispatch({
                            meta: { actionTime: Date.now(), catalogId: catalogId },
                            payload: response.data,
                            type: LOAD_CATALOG_BIDDING_SUCCESS
                        });
                        _context.next = 15;
                        break;

                    case 12:
                        _context.prev = 12;
                        _context.t0 = _context['catch'](2);

                        dispatch({
                            error: true,
                            meta: { catalogId: catalogId },
                            payload: _context.t0,
                            type: LOAD_CATALOG_BIDDING_FAIL
                        });

                    case 15:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[2, 12]]);
    }));

    return function fetchIfNeeded(_x) {
        return _ref.apply(this, arguments);
    };
}();

var fetchCatalogBiddingIfNeeded = exports.fetchCatalogBiddingIfNeeded = function fetchCatalogBiddingIfNeeded(catalogId) {
    return function (dispatch, getState) {
        return Array.isArray(catalogId) ? _promise2.default.all(catalogId.map(function (id) {
            return fetchIfNeeded({ catalogId: id, dispatch: dispatch, getState: getState });
        })) : fetchIfNeeded({ catalogId: catalogId, dispatch: dispatch, getState: getState });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalogBiddingInfo.js
// module id = WDPF
// module chunks = 60